export const login = {
    loadingRegistrationForm : false,
}
